/**
 * 平台: fusion端webview
 * 通用能力:
 * 1.bridge: hypassengerBridge
 * 2.登录: hypassengerIsLogin | hypassengerLogin
 * 3.定位: hypassengerLocate
 * 4.订阅: None
 * 5.分享: None
 * 6.goTo: hypassengerCommonJump
 * 7.保存图片: hypassengerSaveImg
 */
import { fusionBridge, fusionLocate, fusionIsLogin, fusionLogin, fusionSetLoginConfig, fusionSetShare, fusionInvokeShare, fusionPay, h5Pay, fusionSaveImg, fusionGetSystemInfo, passengerCommonJump } from './_common';
import { is } from '../../xenv';
import { compareVersion } from '../../version';
const getAppVersion = () => new Promise(resolve => {
    try {
        fusionBridge.getSystemInfo({}, res => resolve(res.appversion));
    }
    catch {
        resolve('');
    }
});
const hypassengerPay = async (params) => {
    if (is('android')) {
        const appVersion = await getAppVersion() || '';
        const useH5Pay = compareVersion(appVersion, '1.0.4') < 0;
        return useH5Pay ? h5Pay(params) : fusionPay(params);
    }
    return fusionPay(params);
};
export { fusionBridge as hypassengerBridge, fusionLocate as hypassengerLocate, fusionIsLogin as hypassengerIsLogin, fusionLogin as hypassengerLogin, fusionSetLoginConfig as hypassengerSetLoginConfig, fusionSetShare as hypassengerSetShare, fusionInvokeShare as hypassengerInvokeShare, hypassengerPay, fusionSaveImg as hypassengerSaveImg, fusionGetSystemInfo as hypassengerGetSystemInfo, passengerCommonJump as hypassengerCommonJump };
